import * as tslib_1 from "tslib";
import { Event } from "./Event";
/**
/// @eventType	flash.events.KeyboardEvent.KEY_DOWN
[Event(name="keyDown", type="flash.events.KeyboardEvent")]

/// @eventType	flash.events.KeyboardEvent.KEY_UP
[Event(name="keyUp", type="flash.events.KeyboardEvent")]

 * A KeyboardEvent object id dispatched in response to user input through a keyboard.
 * There are two types of keyboard events: <codeph class="+ topic/ph pr-d/codeph ">KeyboardEvent.KEY_DOWN</codeph> and
 * <codeph class="+ topic/ph pr-d/codeph ">KeyboardEvent.KEY_UP</codeph><p class="- topic/p ">Because mappings between keys and specific characters vary by device
 * and operating system, use the TextEvent event type for processing character input.</p><p class="- topic/p ">To listen globally for key events, listen on the Stage for the capture and target
 * or bubble phase.</p>
 */
var KeyboardEvent = (function (_super) {
    tslib_1.__extends(KeyboardEvent, _super);
    /**
     * Creates an Event object that contains specific information about keyboard events.
     * Event objects are passed as parameters to event listeners.
     * @param	type	The type of the event. Possible values are:
     *   KeyboardEvent.KEY_DOWN and KeyboardEvent.KEY_UP
     * @param	bubbles	Determines whether the Event object participates in the bubbling stage of the event flow.
     * @param	cancelable	Determines whether the Event object can be canceled.
     * @param	charCodeValue	The character code value of the key pressed or released. The character code values returned are English keyboard values. For example, if you press Shift+3, the Keyboard.charCode() property returns # on a Japanese keyboard, just as it does on an English keyboard.
     * @param	keyCodeValue	The key code value of the key pressed or released.
     * @param	keyLocationValue	The location of the key on the keyboard.
     * @param	ctrlKeyValue	On Windows, indicates whether the Ctrl key is activated. On Mac, indicates whether either the Ctrl key or the Command key is activated.
     * @param	altKeyValue	Indicates whether the Alt key modifier is activated (Windows only).
     * @param	shiftKeyValue	Indicates whether the Shift key modifier is activated.
     * @param	controlKeyValue	Indicates whether the Control key is activated on Mac, and whether the Control or Ctrl keys are activated on WIndows and Linux.
     * @param	commandKeyValue	Indicates whether the Command key is activated (Mac only).
     */
    function KeyboardEvent(type, bubbles, cancelable, charCodeValue, keyCodeValue, keyLocationValue, ctrlKeyValue, altKeyValue, shiftKeyValue) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (charCodeValue === void 0) { charCodeValue = 0; }
        if (keyCodeValue === void 0) { keyCodeValue = 0; }
        if (keyLocationValue === void 0) { keyLocationValue = 0; }
        if (ctrlKeyValue === void 0) { ctrlKeyValue = false; }
        if (altKeyValue === void 0) { altKeyValue = false; }
        if (shiftKeyValue === void 0) { shiftKeyValue = false; }
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    Object.defineProperty(KeyboardEvent.prototype, "altKey", {
        get: function () {
            return this._altKey;
        },
        set: function (value) {
            this._altKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "charCode", {
        get: function () {
            return this._charCode;
        },
        set: function (value) {
            this._charCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "ctrlKey", {
        get: function () {
            return this._ctrlKey;
        },
        set: function (value) {
            this._ctrlKey = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "keyCode", {
        get: function () {
            return this._keyCode;
        },
        set: function (value) {
            this._keyCode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "keyLocation", {
        /**
         * Indicates the location of the key on the keyboard. This is useful for differentiating keys
         * that appear more than once on a keyboard. For example, you can differentiate between the
         * left and right Shift keys by the value of this property: KeyLocation.LEFT
         * for the left and KeyLocation.RIGHT for the right. Another example is
         * differentiating between number keys pressed on the standard keyboard
         * (KeyLocation.STANDARD) versus the numeric keypad (KeyLocation.NUM_PAD).
         */
        get: function () {
            console.log("keyLocation not implemented yet in flash/KeyboardEvent");
            return 0;
        },
        set: function (value) {
            console.log("keyLocation not implemented yet in flash/KeyboardEvent");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(KeyboardEvent.prototype, "shiftKey", {
        get: function () {
            return this._shiftKey;
        },
        set: function (value) {
            this._shiftKey = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a copy of the KeyboardEvent object and sets the value of each property to match that of the original.
     * @return	A new KeyboardEvent object with property values that match those of the original.
     */
    KeyboardEvent.prototype.clone = function () {
        console.log("clone not implemented yet in flash/KeyboardEvent");
        return null;
    };
    /**
     * Returns a string that contains all the properties of the KeyboardEvent object. The string
     * is in the following format:
     * [KeyboardEvent type=value bubbles=value cancelable=value ... shiftKey=value]
     * @return	A string that contains all the properties of the KeyboardEvent object.
     */
    KeyboardEvent.prototype.toString = function () {
        console.log("toString not implemented yet in flash/KeyboardEvent");
        return "";
    };
    /**
     * Indicates that the display should be rendered after processing of this event completes, if the display
     * list has been modified
     */
    KeyboardEvent.prototype.updateAfterEvent = function () {
        console.log("updateAfterEvent not implemented yet in flash/KeyboardEvent");
    };
    return KeyboardEvent;
}(Event));
export { KeyboardEvent };
/**
 * The KeyboardEvent.KEY_DOWN constant defines the value of the type property of a keyDown event object.
 *
 *   This event has the following properties:PropertyValuebubblestruecancelabletrue in AIR, false in Flash Player;
 * in AIR, canceling this event prevents the character from being entered into a text field.charCodeThe character code value of the key pressed or released.commandKeytrue on Mac if the Command key is active. Otherwise, falsecontrolKeytrue on Windows and Linux if the Ctrl key is active. true on Mac if either the Control key is active. Otherwise, falsectrlKeytrue on Windows and Linux if the Ctrl key is active. true on Mac if either the Ctrl key or the Command key is active. Otherwise, false.currentTargetThe object that is actively processing the Event
 * object with an event listener.keyCodeThe key code value of the key pressed or released.keyLocationThe location of the key on the keyboard.shiftKeytrue if the Shift key is active; false if it is inactive.targetThe InteractiveObject instance with focus.
 * The target is not always the object in the display list
 * that registered the event listener. Use the currentTarget
 * property to access the object in the display list that is currently processing the event.
 */
KeyboardEvent.KEY_DOWN = "keyDown";
/**
 * The KeyboardEvent.KEY_UP constant defines the value of the type property of a keyUp event object.
 * This event has the following properties:PropertyValuebubblestruecancelablefalse; there is no default behavior to cancel.charCodeContains the character code value of the key pressed or released.commandKeytrue on Mac if the Command key is active. Otherwise, falsecontrolKeytrue on Windows and Linux if the Ctrl key is active. true on Mac if either the Control key is active. Otherwise, falsectrlKeytrue on Windows if the Ctrl key is active. true on Mac if either the Ctrl key or the Command key is active. Otherwise, false.currentTargetThe object that is actively processing the Event
 * object with an event listener.keyCodeThe key code value of the key pressed or released.keyLocationThe location of the key on the keyboard.shiftKeytrue if the Shift key is active; false if it is inactive.targetThe InteractiveObject instance with focus.
 * The target is not always the object in the display list
 * that registered the event listener. Use the currentTarget
 * property to access the object in the display list that is currently processing the event.
 */
KeyboardEvent.KEY_UP = "keyUp";
